<template>
  <main class="qi-login">
    <div class="qi-wallpaper"></div>
    <div class="qi-form">
      <a href="#" class="logo login">
        <img src="@/assets/qi-logo-branco.svg" alt="Logo QI" />
      </a>
      <Login></Login>
    </div>
  </main>
</template>

<script>
import Login from "./Login.vue";
export default {
  name: "Home",
  components: {
    Login,
  },
};
</script>

<style>
</style>
